/** SPA — client-only, no SSR. */
export const ssr = false;
/** Off: prerender creates real dirs (clients/, documents/, …) that nginx $uri/ 403s. */
export const prerender = false;
